/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useRef } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Alert, Button, InputGroup,
  NavItem, NavLink, Nav, TabPane, TabContent,
} from 'reactstrap';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { post, get } from '../../helpers/api_helper';
import TagSelector from '../Common/TagSelector';

import GoogleFiles from '../Common/GoogleFiles';
import CompatibilityFieldset from '../Device/CompatibilityFieldset';
import ImagesFieldset from '../Common/ImagesFieldset';
import IdentifierFieldset from '../Common/IdentifierFieldset';
import BoardNumberFieldset from '../Common/BoardNumberFieldset';
import EncompassMapper from '../Mappers/EncompassMapper';
import SpyScraperButton from '../Common/SpyScraperButton';

const validationMessages = (error) => (typeof error === 'string'
  ? [error]
  : Object.values(error || {}).flatMap(validationMessages));

function ItemForm(props) {
  const {
    entity,
    t,
  } = props;

  const partMnfctrRef = useRef(null);
  const deviceMnfctrRef = useRef(null);

  const [, setLoading] = useState(false);
  const [compatibilityLoading, setCompatibilityLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [brands, setBrands] = useState([]);
  const [mapSearch, setMapSearch] = useState(null);
  const [preTags, setPreTags] = useState([]);
  const [harvestModels, setHarvestModels] = useState(false);

  const mapSearchRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const result = await get('/api/devices/brands');
      setBrands(result);
    };

    const fetchFrequentTags = async () => {
      const result = await get('/api/items/tag/frequent/12');

      setPreTags(result);
    };

    fetchFrequentTags();
    fetchData();
  }, [entity]);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    if (compatibilityLoading) {
      toastr.info(t('Please wait for the models to finish loading.'));
      return;
    }

    try {
      setLoading(true);
      const action = entity.id ? '/api/items/save' : '/api/items/create';
      const result = await post(action, values);
      setErrorMessage(null);

      toastr.success(t(`Item ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const getDevices = async (models) => {
    try {
      const devices = await Promise.all(
        models.map((model) => get(`/api/devices/find?brand=${encodeURIComponent(model.brand)}&model=${encodeURIComponent(model.model)}&create=1`)),
      );

      return devices.filter((dev) => dev !== null);
    } catch (error) {
      toastr.error(t('Error'), error.message);
      return [];
    }
  };

  const identifierSchema = Yup.array().of(
    Yup.object().shape({
      label: Yup.string().required(t('Label is required')),
      code: Yup.string().required(t('Code is required')),
    }),
  );

  const ValidationSchema = Yup.object().shape({
    condition: Yup.mixed().required(t('Condition is required')),
    customs_description: Yup.string().nullable(),
    value_usd: Yup.number().nullable(),
    weight: Yup.number().nullable(),
    ship_dims: Yup.string().nullable(),
    tags: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(t('Tag is required')).matches(/^[\w -/]+$/, { message: t('Tags can only contain letters, numbers, dashes, and spaces') }),
        id: Yup.number(),
      }),
    ),
    identifiers: identifierSchema,
    images: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(t('Label is required')),
        url: Yup.string().url(t('Must be a URL')).required(t('URL is required')),
        is_default: Yup.boolean(),
      }),
    ),
    devices: Yup.array().of(
      Yup.object().shape({
        id: Yup.number().required(t('Device is required')),
        version: Yup.string().nullable(),
      }),
    ),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      {em}
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => save(values)}
      >
        {({
          touched, errors, values, setFieldValue, submitCount,
        }) => (
          <Form className="mt-3" id="ItemEditForm" autoComplete="off" noValidate>
            {submitCount > 0 && Object.keys(errors).length > 0 && (
              <Alert color="danger" role="alert">
                {t('Item was not saved. Correct the following fields and try again:')}
                <ul className="mb-0">
                  {Object.entries(errors).map(([field, error]) => (
                    <li key={field}>
                      {field}
                      {': '}
                      {Array.from(new Set(validationMessages(error))).join(', ')}
                    </li>
                  ))}
                </ul>
              </Alert>
            )}
            <Row>
              <Col md="3">
                <Nav pills className="flex-column">
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '1',
                      })}
                      onClick={() => {
                        setActiveTab('1');
                      }}
                    >
                      {props.t('General')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '2',
                      })}
                      onClick={() => {
                        setActiveTab('2');
                      }}
                    >
                      {props.t('Compatibility')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '3',
                      })}
                      onClick={() => {
                        setActiveTab('3');
                      }}
                    >
                      {props.t('Images')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '4',
                      })}
                      onClick={() => {
                        setActiveTab('4');
                      }}
                    >
                      {props.t('Customs')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '5',
                      })}
                      onClick={() => {
                        setActiveTab('5');
                      }}
                    >
                      {props.t('Mapping')}
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
              <Col md="9">
                <TabContent
                  activeTab={activeTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <Field name="id" type="hidden" />
                    <Field name="profile_id" type="hidden" />

                    <div className="hstack gap-2">
                      <SpyScraperButton
                        parser="encompass"
                        color="dark"
                        onData={async (data) => {
                          console.log('encompass models', data.models);

                          if (data.brand !== undefined) {
                            setFieldValue('manufacturer', data.brand);

                            const models = data.models?.map((x) => ({
                              model: x.model,
                              brand: x.brand || data.brand,
                            })) || [];
                            const devices = await getDevices(models);

                            setFieldValue('devices', devices?.map((x) => ({
                              id: x.id, brand: x.brand, model: x.model, version: x.version,
                            })) || []);
                          }

                          setFieldValue('part_number', data.part_number);
                          setFieldValue('images', data.images?.slice(0, 2).filter((x) => x.path.match(/^http/)).map((x, i) => (
                            { url: x.path, label: `Photo ${i + 1}`, is_default: i === 0 }
                          )) || []);

                          toastr.success(t('Applied mapping data to form'), 'SpyScraper');
                        }}
                      />

                      <SpyScraperButton
                        parser="partsdr"
                        color="dark"
                        onData={async (data) => {
                          if (data.brand !== undefined) {
                            setFieldValue('manufacturer', data.brand);

                            const models = data.models?.map((x) => ({
                              model: x.model,
                              brand: x.brand || data.brand,
                            })) || [];
                            const devices = await getDevices(models);

                            setFieldValue('devices', devices?.map((x) => ({
                              id: x.id, brand: x.brand, model: x.model, version: x.version,
                            })) || []);
                          }

                          setFieldValue('part_number', data.part_number);
                          setFieldValue('images', data.images?.slice(0, 2).filter((x) => x.path.match(/^http/)).map((x, i) => (
                            { url: x.path, label: `Photo ${i + 1}`, is_default: i === 0 }
                          )) || []);

                          toastr.success(t('Applied mapping data to form'), 'SpyScraper');
                        }}
                      />
                    </div>

                    <div className="hstack gap-2">
                      <SpyScraperButton
                        parser="encompass"
                        color="info"
                        onData={async (data) => {
                          if (data.brand !== undefined) {
                            const models = data.models?.map((x) => ({
                              model: x.model,
                              brand: x.brand || data.brand,
                            })) || [];
                            const devices = await getDevices(models);

                            const incomingDevices = devices?.map((x) => ({
                              id: x.id,
                              brand: x.brand,
                              model: x.model,
                              version: x.version,
                            })) || [];
                            const existingDevices = values.devices || [];
                            const merged = [
                              ...existingDevices,
                              ...incomingDevices.filter((incoming) => !existingDevices
                                .some((existing) => (
                                  existing.id === incoming.id
                                  || (
                                    existing.brand === incoming.brand
                                    && existing.model === incoming.model
                                    && (existing.version || '') === (incoming.version || '')
                                  )
                                ))),
                            ];
                            setFieldValue('devices', merged);
                          }
                          toastr.success(t('Applied compatibility to form'), 'SpyScraper');
                        }}
                      >
                        <>
                          <strong>Encompass</strong>
                          <br />
                          <span>Compatibility Only</span>
                        </>
                      </SpyScraperButton>

                      <SpyScraperButton
                        parser="partsdr"
                        color="info"
                        onData={async (data) => {
                          if (data.brand !== undefined) {
                            const models = data.models?.map((x) => ({
                              model: x.model,
                              brand: x.brand || data.brand,
                            })) || [];
                            const devices = await getDevices(models);

                            const incomingDevices = devices?.map((x) => ({
                              id: x.id,
                              brand: x.brand,
                              model: x.model,
                              version: x.version,
                            })) || [];
                            const existingDevices = values.devices || [];
                            const merged = [
                              ...existingDevices,
                              ...incomingDevices.filter((incoming) => !existingDevices
                                .some((existing) => (
                                  existing.id === incoming.id
                                  || (
                                    existing.brand === incoming.brand
                                    && existing.model === incoming.model
                                    && (existing.version || '') === (incoming.version || '')
                                  )
                                ))),
                            ];
                            setFieldValue('devices', merged);
                          }
                          toastr.success(t('Applied compatibility to form'), 'SpyScraper');
                        }}
                      >
                        <>
                          <strong>PartsDr</strong>
                          <br />
                          <span>Compatibility Only</span>
                        </>
                      </SpyScraperButton>
                    </div>

                    <div className="mb-3">
                      <Label
                        for="part_number"
                        className="col-form-label"
                      >
                        {props.t('Part Number')}
                      </Label>
                      <Field
                        type="text"
                        className={`form-control ${(errors.part_number && touched.part_number ? 'is-invalid' : '')}`}
                        id="part_number"
                        name="part_number"
                        onChange={(e) => {
                          setFieldValue('part_number', e.target.value);
                        }}
                      />
                      <ErrorMessage
                        name="part_number"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="mb-3">
                      <Label
                        for="condition"
                        className="col-sm-3 col-form-label"
                      >
                        {props.t('Condition')}
                      </Label>
                      <Field
                        as="select"
                        className={`form-control ${(errors.condition && touched.condition ? 'is-invalid' : '')}`}
                        id="condition"
                        name="condition"
                      >
                        <option>{props.t('Select...')}</option>
                        <option value="New">{props.t('Brand New')}</option>
                        <option value="Like New">{props.t('Like New')}</option>
                        <option value="Used">{props.t('Used')}</option>
                        <option value="Refurbished">{props.t('Refurbished')}</option>
                        <option value="Other">{props.t('Other')}</option>
                      </Field>
                      <ErrorMessage
                        name="condition"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="mb-3">
                      <Label className="col-form-label">
                        {props.t('Tags')}
                      </Label>
                      <div className="d-flex flex-wrap gap-1 mb-2">
                        {preTags.sort((a, b) => a.label.localeCompare(b.label))
                          .map((tag, index) => (
                            <React.Fragment key={tag.id}>
                              {index % 4 === 0 && index !== 0 && <div className="w-100" />}
                              <Button
                                color="info"
                                className="btn-sm text-dark"
                                onClick={() => {
                                  setFieldValue('tags', [...values.tags, tag]);
                                }}
                              >
                                {tag.label}
                              </Button>
                            </React.Fragment>
                          ))}
                      </div>
                      <TagSelector
                        id="tags_selector"
                        initialTags={values.tags}
                        onUpdate={(tags) => {
                          setFieldValue('tags', tags);
                        }}
                      />
                    </div>

                    <div className="mb-3">
                      <Label
                        for="manufacturer"
                        className="col-form-label"
                      >
                        {props.t('Part Manufacturer')}
                      </Label>
                      <div className="position-relative">
                        <Field
                          type="text"
                          innerRef={partMnfctrRef}
                          className={`form-control ${(errors.manufacturer && touched.manufacturer ? 'is-invalid' : '')}`}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                            }

                            if (e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                          id="manufacturer"
                          name="manufacturer"
                        />
                        {values.manufacturer && values.manufacturer.length > 0
                          && (partMnfctrRef.current === document.activeElement
                            || !brands.includes(values.manufacturer))
                          && (
                            <div className="position-absolute" style={{ width: '100%', marginTop: '1px', zIndex: 100 }}>
                              <ul className="list-group">
                                {brands.filter((brand) => (
                                  brand.toLowerCase().startsWith(values.manufacturer.toLowerCase())
                                )).map((brand) => (
                                  <li
                                    key={brand.id}
                                    className="list-group-item position-relative"
                                    style={{ padding: '0px' }}
                                  >
                                    <a
                                      href="#"
                                      className="text-dark"
                                      style={{ display: 'block', padding: '0.47rem 0.75rem' }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setFieldValue('manufacturer', brand);

                                        setTimeout(() => {
                                          deviceMnfctrRef.current.focus();
                                        }, 100);
                                      }}
                                    >
                                      {brand}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                      </div>
                      <ErrorMessage
                        name="manufacturer"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="mb-3">
                      <Label
                        for="device_manufacturer"
                        className="col-form-label"
                      >
                        {props.t('Device Manufacturer')}
                      </Label>
                      <div className="position-relative">
                        <Field
                          type="text"
                          innerRef={deviceMnfctrRef}
                          className={`form-control ${(errors.device_manufacturer && touched.device_manufacturer ? 'is-invalid' : '')}`}
                          id="device_manufacturer"
                          name="device_manufacturer"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                            }

                            if (e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                        />

                        {values.device_manufacturer && values.device_manufacturer.length > 0
                          && (deviceMnfctrRef.current === document.activeElement
                            || !brands.includes(values.device_manufacturer))
                          && (
                            <div className="position-absolute" style={{ width: '100%', marginTop: '1px', zIndex: 100 }}>
                              <ul className="list-group">
                                {brands.filter((brand) => (
                                  brand
                                    .toLowerCase()
                                    .startsWith(values.device_manufacturer.toLowerCase())
                                )).map((brand) => (
                                  <li
                                    key={brand.id}
                                    className="list-group-item position-relative"
                                    style={{ padding: '0px' }}
                                  >
                                    <a
                                      href="#"
                                      className="text-dark"
                                      style={{ display: 'block', padding: '0.47rem 0.75rem' }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setFieldValue('device_manufacturer', brand);
                                      }}
                                    >
                                      {brand}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                      </div>
                    </div>

                    <style>
                      {`
                        .list-group-item a:focus {
                          background-color: rgba(249, 195, 25, 1) !important;
                        }
                      `}
                    </style>

                    <Row>
                      <Col md="6">
                        <label>{props.t('Alert')}</label>
                        <Field name="alert" as="textarea" rows="2" className="form-control" />
                      </Col>
                      <Col md="6">
                        <label>{props.t('Scrap Level')}</label>
                        <Field name="scrap" type="number" className="form-control" />
                      </Col>
                    </Row>

                    <label className="mt-3">{props.t('Attributes')}</label>
                    <FieldArray name="boardNumbers" className="mt-3">
                      {(arrayHelpers) => (
                        <BoardNumberFieldset arrayHelpers={arrayHelpers} />
                      )}
                    </FieldArray>

                    <label className="mt-3">{props.t('Unique Item Identifiers')}</label>
                    <FieldArray name="identifiers" className="mt-3">
                      {(arrayHelpers) => (
                        <IdentifierFieldset arrayHelpers={arrayHelpers} />
                      )}
                    </FieldArray>
                  </TabPane>
                  <TabPane tabId="2">
                    <FieldArray name="devices" className="mt-3">
                      {(arrayHelpers) => (
                        <div>
                          <label>{props.t('Compatible Devices')}</label>
                          <CompatibilityFieldset
                            arrayHelpers={arrayHelpers}
                            onLoadingChange={(isLoading) => {
                              setCompatibilityLoading(isLoading);
                              props.onBusyChange(isLoading);
                            }}
                          />
                        </div>
                      )}
                    </FieldArray>
                  </TabPane>
                  <TabPane tabId="3">
                    <FieldArray name="images" className="mt-3">
                      {(arrayHelpers) => (
                        <>
                          <GoogleFiles
                            onFileUpload={(pubUrl) => {
                              arrayHelpers.push({ url: pubUrl, label: '', is_default: false });
                            }}
                            bucket="sj_base_party_images"
                          />

                          <ImagesFieldset arrayHelpers={arrayHelpers} />
                        </>
                      )}
                    </FieldArray>
                  </TabPane>

                  <TabPane tabId="4">
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label
                            for="value_usd"
                            className="col-form-label"
                          >
                            {props.t('Monetary Value USD')}
                          </Label>
                          <Field
                            type="number"
                            step=".01"
                            min=".01"
                            className={`form-control ${(errors.value_usd && touched.value_usd ? 'is-invalid' : '')}`}
                            id="value_usd"
                            name="value_usd"
                          />
                          <ErrorMessage
                            name="value_usd"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </Col>

                      <Col lg="6">
                        <div className="mb-3">
                          <Label
                            for="weight"
                            className="col-form-label"
                          >
                            {props.t('Shipping Weight')}
                          </Label>
                          <Field
                            type="number"
                            step=".01"
                            min="0"
                            className={`form-control ${(errors.weight && touched.weight ? 'is-invalid' : '')}`}
                            id="weight"
                            name="weight"
                          />
                          <ErrorMessage
                            name="weight"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </Col>
                    </Row>

                    <div className="mb-3">
                      <Label
                        for="ship_dims"
                        className="col-form-label"
                      >
                        {props.t('Shipping Dimensions')}
                      </Label>
                      <Field
                        className={`form-control ${(errors.ship_dims && touched.ship_dims ? 'is-invalid' : '')}`}
                        id="ship_dims"
                        name="ship_dims"
                        placeholder="LxWxH"
                      />
                      <ErrorMessage
                        name="ship_dims"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="mb-3">
                      <Label
                        for="customs_description"
                        className="col-sm-3 col-form-label"
                      >
                        {props.t('Customs Description')}
                      </Label>
                      <Field
                        className={`form-control ${(errors.customs_description && touched.customs_description ? 'is-invalid' : '')}`}
                        id="customs_description"
                        name="customs_description"
                      />
                      <ErrorMessage
                        name="customs_description"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </TabPane>

                  <TabPane tabId="5">
                    <div className="mb-3">
                      <Label
                        for="search"
                        className="col-form-label"
                      >
                        {props.t('Search for Data')}
                      </Label>
                      <InputGroup>
                        <input type="text" ref={mapSearchRef} className="form-control" id="search" name="search" placeholder={values.part_number} />
                        <Button color="primary" type="button" className="ml-2" onClick={() => { setMapSearch(mapSearchRef.current.value); }}>{t('Search')}</Button>
                      </InputGroup>
                    </div>

                    <div className="form-checkbox">
                      <input type="checkbox" id="harvest_models" checked={harvestModels} onChange={() => { setHarvestModels(!harvestModels); }} />
                      <label htmlFor="harvest_models" className="ps-2">
                        {t('Harvest Compatibility only?')}
                      </label>
                    </div>

                    {mapSearch !== null && (
                      <div className="mt-4">
                        <EncompassMapper
                          search={mapSearch || values.part_number}
                          onAccept={(ent) => {
                            setFieldValue('devices', ent.devices);

                            if (!harvestModels) {
                              setFieldValue('part_number', ent.part_number);
                              setFieldValue('images', ent.images.map((x, i) => ({ url: x, label: `Photo ${i + 1}`, is_default: i === 0 })));
                              setFieldValue('manufacturer', ent.manufacturer);
                              setFieldValue('device_manufacturer', ent.manufacturer);
                              setFieldValue('ship_dims', ent.dimensions);

                              setFieldValue('value_usd', ent.value_usd);
                              setFieldValue('customs_description', ent.customs_description);

                              setActiveTab('1');
                            } else {
                              setActiveTab('2'); // Compatibility
                            }
                          }}
                        />
                      </div>
                    )}
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

ItemForm.defaultProps = {
  entity: {
    weight: null,
    ship_dims: '',
    part_number: '',
    tags: [],
    identifiers: [],
    boardNumbers: [],
    images: [],
    devices: [],
    profile_id: null,
    customs_description: '',
    value_usd: 0,
  },
  onSuccess: () => { },
  onBusyChange: () => { },
};

ItemForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
  onBusyChange: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(ItemForm));
